<div class="viz">
  <div class="viz__left">
    <div class="viz__card viz__card--files">
      <div class="viz__card-title-row">
        <h4 class="viz__card-title">Version Files</h4>
      </div>

      @if (loadingFiles) {
      <div class="viz__loading">
        <div class="viz__spinner"></div>
        <p>Loading files...</p>
      </div>
      }

      @if (!loadingFiles && displayFiles.length > 0) {
      <div class="viz__file-list">
        @for (file of displayFiles; track file.name) {
        <div class="viz__file-item" [class.viz__file-item--selected]="selectedFile?.name === file.name"
          [class.viz__file-item--disabled]="!isFileSupportedForVisualisation(file)"
          (click)="isFileSupportedForVisualisation(file) && onSelectedFileChange(file)">
          <img
            class="viz__file-icon"
            src="/icons/file-document.svg"
            width="20"
            height="20"
            alt=""
          />
          <span class="viz__file-name">{{ file.name }}</span>
        </div>
        }
      </div>
      }

      @if (!loadingFiles && !loading && displayFiles.length === 0) {
      <div class="viz__empty viz__empty--files">
        <p>No files available</p>
      </div>
      }
    </div>
  </div>

  <div class="viz__right">
    <div class="viz__card viz__card--chart">
      <div class="viz__chart-header">
        <h4 class="viz__chart-title">
          Visualisation for
          @if (selectedFile?.name) {
          <span class="viz__chart-file"> {{ selectedFile?.name }}</span>
          }
        </h4>
        @if (selectedFile && (selectedFileSizeDisplay || selectedFileLastUpdatedDisplay || license())) {
        <div class="viz__chart-metadata">
          @if (selectedFileSizeDisplay) {
          <div class="viz__chart-meta-row">
            <span class="viz__chart-meta-label">File size</span>
            <span class="viz__chart-meta-value">{{ selectedFileSizeDisplay }}</span>
          </div>
          }
          @if (selectedFileLastUpdatedDisplay) {
          <div class="viz__chart-meta-row">
            <span class="viz__chart-meta-label">Last updated</span>
            <span class="viz__chart-meta-value">{{ selectedFileLastUpdatedDisplay }}</span>
          </div>
          }
          @if (license()) {
          <div class="viz__chart-meta-row">
            <span class="viz__chart-meta-label">License</span>
            <span class="viz__chart-meta-value">{{ license() }}</span>
          </div>
          }
        </div>
        }

        @if (selectedFile) {
        <div class="viz__chart-separator"></div>
        }
      </div>

      @if (loading) {
      <div class="viz__loading">
        <div class="viz__spinner"></div>
        <p>Loading data...</p>
      </div>
      }

      @if (error && !loading) {
      <div class="viz__error">
        <p>{{ error }}</p>
      </div>
      }

      @if (!loading && !error && tableData.length > 0) {
      <div class="viz__chart-content">
        <div class="viz__chart-config">
          <div class="viz__controls">
            <div class="viz__control-group">
              <label class="viz__control-label">Chart Type</label>
              <select class="viz__select" [value]="chartType" (change)="onChartTypeChange($event)">
                @for (type of chartTypes; track type.key) {
                <option [value]="type.key">{{ type.label }}</option>
                }
              </select>
            </div>

            <div class="viz__control-group">
              <label class="viz__control-label">{{ chartTypeLabel === 'Line Chart' ? 'X-Axis' : 'Dimension' }}</label>
              <select class="viz__select" [value]="selectedDimension" (change)="onDimensionChange($event)">
                @for (h of tableHeaders; track h) {
                <option [value]="h">{{ h }}</option>
                }
              </select>
            </div>

            @if (chartTypeLabel === 'Line Chart') {
            <div class="viz__control-group">
              <label class="viz__control-label">Y-Axis</label>
              <select class="viz__select" [value]="selectedSeries" (change)="onSeriesChange($event)">
                @for (h of tableHeaders; track h) {
                <option [value]="h">{{ h }}</option>
                }
              </select>
            </div>
            }

            @if (chartTypeLabel === 'Bar Chart' || chartTypeLabel === 'Pie Chart') {
            <div class="viz__control-group">
              <label class="viz__control-label">Metric</label>
              <select class="viz__select" [value]="selectedMetric" (change)="onMetricChange($event)">
                @for (m of metricTypes; track m) {
                <option [value]="m">{{ m }}</option>
                }
              </select>
            </div>
            }

            @if (selectedColumnIsNumeric && selectedMetric !== 'count' && chartTypeLabel !== 'Line Chart' &&
            groupByColumns.length > 0) {
            <div class="viz__control-group">
              <label class="viz__control-label">Group By</label>
              <select class="viz__select" [value]="selectedGroupByColumn" (change)="onGroupByColumnChange($event)">
                @for (g of groupByColumns; track g) {
                <option [value]="g">{{ g }}</option>
                }
              </select>
            </div>
            }
          </div>
        </div>

        <div class="viz__chart-area">
          <div echarts [options]="chartOptions" class="viz__echart"></div>
        </div>
      </div>
      }

      @if (!loading && !error && tableData.length === 0 && selectedFile) {
      <div class="viz__empty">
        <p>No data to visualise. Select a supported file (CSV, TSV, XLSX, Parquet, JSON).</p>
      </div>
      }

      @if (!loading && !error && !selectedFile && displayFiles.length > 0) {
      <div class="viz__empty">
        <p>Select a file from the list to visualise</p>
      </div>
      }
    </div>
  </div>
</div>